import React, { useState, useEffect, useCallback, useContext } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { BASE_URL } from '../api/api';

import '../styles/componentsStyles/ContentCard.scss'

import PDFfile from '../assets/files/web3.pdf'
import Logo from "../assets/logos/codemmit-logo.png"

import thumbnail from "../assets/images/thum.jpg"
import PictureInPicture from "../assets/icons/picture-in-picture.svg"
import ThreeDot from "../assets/icons/three-dots.svg"
import Edit from "../assets/icons/edit-square.svg"
import Delete from "../assets/icons/delete.svg"

// import context 
import { Auth } from '../context/Auth';
import { UpdatePost } from '../context/UpdatePostAfterUploading';

// File viewer
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// File uploader 
import { useDropzone } from 'react-dropzone';

// CODE RELATED TO PDF VIEWER 
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// CODE RELATED TO PDF VIEWER (react-pdf) END

const ContentCard = ({ contentData }) => {

    // Storing uploaded prescription file in "uploadedFiles" State
    const [contentDataState, setContentDataState] = useState(contentData);
    const [uploadedFiles, setUploadedFile] = useState([]);
    const [showPdfView, setShowPdfView] = useState(false);
    // View or not the uploaded file 
    const [viewFile, setViewFile] = useState(false)
    const [docToView, setDocToView] = useState([])
    // PDF VIEWER 
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [showOptionsMenu, setShowOptionsMenu] = useState(false);
    const [owner, setOwner] = useState(false);
    const [showDeleteConfirmationBox, setShowDeleteConfirmationBox] = useState(false);

    const auth = useContext(Auth)
    const updatePost = useContext(UpdatePost)
    const navigate = useNavigate();


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const idFromUrl = queryParams.get('id');

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const onDrop = useCallback(acceptedFiles => {
        // Do something with the files

        // setUploadedFile([{ ...acceptedFiles }, { acceptedFiles }]);
        setUploadedFile(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));

    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    // console.log(uploadedFiles, 'uploaded file');

    function openFile() {
        setViewFile(true);
    }

    // Uploaded file thumbnail 
    const fileThumbnail = uploadedFiles.map(file => {

        // For viewing uploaded file
        if (file.name.substring(file.name.lastIndexOf('.') + 1) === "pdf") {

            return (
                <>
                    <div className="upload-content-card__nav-btn-previous" onClick={() => { if (pageNumber >= 2) { setPageNumber(pageNumber - 1) } }}><span>&lt;</span></div>
                    <Document file={PDFfile} onLoadSuccess={onDocumentLoadSuccess} // Revoke data uri after image is loaded
                        className='upload-content-card__thumbnail'>
                        <Page pageNumber={pageNumber} />
                    </Document>
                    <div className="upload-content-card__nav-btn-next" onClick={() => { if (pageNumber < numPages) { setPageNumber(pageNumber + 1) } }}><span>&gt;</span></div>
                    <p className='upload-content-card__pdf-page-indicator'>
                        {pageNumber}/{numPages}
                    </p>
                </>

            )
        }

        if (file.name.substring(file.name.lastIndexOf('.') + 1) === 'jpg' || 'png' || 'jpeg' || 'PNG' || 'JPEG' || 'JPG') {

            return (
                <img key={file.name}
                    className='upload-content-card__thumbnail'
                    src={file.preview}
                    onClick={openFile}
                    // Revoke data uri after image is loaded
                    onLoad={() => { URL.revokeObjectURL(file.preview) }}
                />
            )
        }
    }
    );

    useEffect(() => {

        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => uploadedFiles.forEach(file => URL.revokeObjectURL(file.preview));
    }, []);

    // Navigate to Browse Content page when clicked on particular card 
    const browseContent = (channelId, fileId, file, fileType) => {
        navigate("/browse");
        // const contentData = JSON.parse(window.sessionStorage.getItem("activeTabDetail"));
        navigate(`/browse/${channelId}?id=${fileId}?type=${fileType}`);

        console.log("DD click");
        // window.sessionStorage.setItem("contentToView", JSON.stringify(uploadedFiles[0]));
    }

    // const contentUploaderFormDisplay = useContext(ContentUploaderFormDisplay);
    const openUploadContentForm = () => {
        // contentUploaderFormDisplay.showContentUploaderFormDispatch({ type: 'openContentUploaderForm' })
    }

    const handlePictureInPictureView = () => {
        setShowPdfView(true);
    }


    const handleMoreOptionsMenu = () => {
        if (showOptionsMenu) {
            setShowOptionsMenu(false);
            console.log("if")
        } else {
            setShowOptionsMenu(true);
            console.log("else")
        }
    }

    const handlePostDelete = () => {
        setShowDeleteConfirmationBox(true);
    }

    const permanentDeletePost = (id) => {
        // Make API call here to delete the post permenently 
        axios.delete(`${BASE_URL}/api/posts/${id}`)
            .then(res => {
                console.log(res, "Delete Post response");
                if (res.data.statusText === "success") {
                    updatePost.updatePostDispatch({ type: "updateThePostAfterDeleting" })
                }

            })
            .catch(err => console.log(err, "Error! deleting post"))
    }


    console.log(contentDataState, "contentData");

    useEffect(() => {
        // Get the userId from context, then fetch the channel Id owned by it and then compare it with the "id" present in search URL
        if (auth.authState.userId) {
            axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: auth.authState.userId })
                .then(res => {
                    console.log(res, "fetch User in Hidden Component");
                    if (res.data.statusText === "success") {
                        if (res.data.user.channelId === idFromUrl) {
                            setOwner(true);
                        }
                    }
                })
                .catch(err => console.log(err))
        } else {
            setOwner(false);
        }
    }, [])


    return (
        <>
            {/* <div className='upload-content-card'>
                <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    {
                        isDragActive ?
                            <p>Drop the files here ...</p> :
                            <p>Drag 'n' drop some files here, or click to select files</p>
                    }
                </div>
            </div>

            <div className="upload-content-card" onClick={openUploadContentForm}>
                <p>Upload PDF or images</p>
            </div> */}

            {
                uploadedFiles.map(file => <div key={file.path} className='upload-content-card' onDoubleClick={() => browseContent(contentDataState.channelId, contentDataState.id, contentDataState.storageKey, "image")}>
                    {fileThumbnail}
                </div>
                )
            }

            <div className="content-card" onDoubleClick={() => browseContent(contentDataState.channelId, contentDataState.id, contentDataState.storageKey, "image")}>
                {
                    showPdfView && <div className="content-card__nav-btn-previous" onClick={() => { if (pageNumber >= 2) { setPageNumber(pageNumber - 1) } }}>
                        <span className="material-symbols-outlined">
                            chevron_left
                        </span>
                    </div>
                }
                {
                    showPdfView ? <Document loading="Loading file..." file={PDFfile} onLoadSuccess={onDocumentLoadSuccess} // Revoke data uri after image is loaded
                        className='content-card__thumbnail'>
                        <Page pageNumber={pageNumber} />
                    </Document> : <img className='content-card__thumbnail' src={contentDataState.thumbnailImage} alt="thumbnail" />
                }

                {
                    showPdfView &&
                    <div className="content-card__nav-btn-next" onClick={() => { if (pageNumber < numPages) { setPageNumber(pageNumber + 1) } }}>
                        <span className="material-symbols-outlined">
                            chevron_right
                        </span>
                    </div>
                }

                {
                    showPdfView && <p className='content-card__pdf-page-indicator'>
                        {pageNumber}/{numPages}
                    </p>
                }

                {/* When clicked on this button then Download PDF, till then only show thumbnail and title, (Pending....)  */}
                <button className='content-card__view-in-card-btn' onClick={handlePictureInPictureView}>
                    <img src={PictureInPicture} alt="rectangle" />
                </button>

                <div className='content-card__title-container'>
                    <img src={Logo} alt="logo" className='content-card__channel-logo' />
                    <p className='content-card__title'>{contentDataState.title}</p>
                </div>

                {
                    owner && <button className='content-card__more-options' onClick={handleMoreOptionsMenu}>
                        <img src={ThreeDot} alt="menu" />
                    </button>
                }

                {
                    owner && <>
                        {
                            showOptionsMenu && <div className="content-card__options-menu">
                                <ul>
                                    <li>
                                        <button >
                                            <img src={Edit} alt="edit" />
                                            <span>Edit Post</span>
                                        </button>
                                        <button onClick={() => handlePostDelete()}>
                                            <img src={Delete} alt="delete" />
                                            <span>Delete</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        }
                    </>
                }

                {
                    showDeleteConfirmationBox && <div className="content-card__delete-post-container">
                        <h4>Are you sure about <b>Deleting</b> this post?</h4>
                        <div className='content-card__delete-confirm'>
                            <button onClick={() => permanentDeletePost(contentDataState.id)}>Delete</button>
                            <button onClick={() => setShowDeleteConfirmationBox(false)}>Cancel</button>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default ContentCard
